export const MissionStatementMessages = {
  SUCCESS_SET_MISSION: 'mission-statement.success-set-mission',
  SUCCESS_DELETE_MISSION: 'mission-statement.success-delete-mission'
};
